





































import { Component, Vue } from "vue-property-decorator";

import BreadcrumbArea from "@/components/common/breadcrumb/BreadcrumbArea.vue";
import BreadcrumbItem from "@/components/common/breadcrumb/BreadcrumbItem.vue";
import BreadcrumbList, {
  BreadcrumbData,
} from "@/components/common/breadcrumb/BreadcrumbList.vue";
import BreadcrumbSep from "@/components/common/breadcrumb/BreadcrumbSep.vue";
import ImportantMessageArea from "@/components/important-message/ImportantMessageArea.vue";
import FlexibleContentArea from "@/components/layout/FlexibleContentArea.vue";
import SiteImageArea from "@/components/layout/SiteImageArea.vue";
import ServiceCategoryTab from "@/components/service/ServiceCategoryTab.vue";
import ServiceGroupItem from "@/components/service/ServiceGroupItem.vue";
import ServiceStatusUpdateHeader from "@/components/service-status/ServiceStatusUpdateHeader.vue";
import StatusExplanationHeader from "../service-status/StatusExplanationHeader.vue";
import { API_ERROR_MESSAGE } from "@/consts/const";
import { RouteName } from "@/consts/route";
import { BaseApiError } from "@/errors/api/base-api-error";
import { ImportantMessageInterface } from "@/interfaces/important-message.interface";
import { ServiceInterface } from "@/interfaces/service.interface";
import { ServiceCategoryInterface } from "@/interfaces/service-category.interface";
import { ServiceGroupInterface } from "@/interfaces/service-group.interface";

@Component({
  components: {
    ImportantMessageArea,
    SiteImageArea,
    ServiceGroupItem,
    ServiceStatusUpdateHeader,
    StatusExplanationHeader,
    ServiceCategoryTab,
    FlexibleContentArea,
    BreadcrumbList,
    BreadcrumbSep,
    BreadcrumbItem,
    BreadcrumbArea,
  },
})
export default class ServicePage extends Vue {
  private updatedTime = new Date().getTime();
  private loading = false;
  private categories: ServiceCategoryInterface[] = [];
  private category: ServiceCategoryInterface | null = null;
  private serviceGroups: ServiceGroupInterface[] = [];
  private isFirstLoading = true;
  private importantMessages: ImportantMessageInterface[] = [];

  async mounted(): Promise<void> {
    try {
      const categories = await this.$service.getCategories(this);
      this.showLoading();

      if (this.$route.name === RouteName.Home) {
        if (categories.length === 0) {
          this.hideLoading();
          await this.$router.push({ name: RouteName.NotFound });

          return;
        }

        await this.$router.push({
          name: RouteName.Service,
          params: { key: categories[0].routeKey },
        });
        // この画面のまま進むこと。returnで抜けてはいけない。
      }

      const category = this.$service.getCategoryByRouteKey(
        categories,
        this.$route.params.key
      );

      if (!category) {
        this.hideLoading();
        await this.$router.push({ name: RouteName.NotFound });
        return;
      }

      this.categories = categories;
      this.category = category;
      this.loadImportantMessages();
      await this.loadServices();
    } catch (e) {
      console.log(e);
      if (this.category) {
        this.errorToast(this.$t(API_ERROR_MESSAGE.FAILED_TO_GET).toString());
      } else {
        this.errorToast(this.$t(API_ERROR_MESSAGE.FAILED_GENERAL).toString());
      }
    } finally {
      if (this.category) {
        this.hideLoading();
      }
    }
  }

  private get breadcrumbs(): BreadcrumbData[] {
    if (!this.category) {
      return [{ name: "Home", route: RouteName.Home }];
    }

    return [
      { name: "Home", route: RouteName.Home },
      {
        name: this.category.name,
        route: RouteName.Service,
        params: { key: this.category.routeKey },
      },
    ];
  }

  private loadImportantMessages(): Promise<void> {
    return this.$api
      .getImportantMessages()
      .then((messages: ImportantMessageInterface[]) => {
        this.importantMessages = messages;
      })
      .catch(() => {
        this.errorToast(this.$t("message.ServicePage.error_toast").toString());
      });
  }

  private loadServices(): Promise<void> {
    return this.$api
      .getServicesInServiceCategory(
        (this.category as ServiceCategoryInterface).id
      )
      .then((serviceGroups: ServiceGroupInterface[]) => {
        this.serviceGroups = serviceGroups;

        if (this.isFirstLoading) {
          this.$nextTick(() => {
            window.scrollTo(0, 0);
          });
        }

        this.isFirstLoading = false;
      })
      .catch((e: BaseApiError) => {
        throw e;
      });
  }

  private get categoryId(): number {
    if (!this.category) {
      return 0;
    }

    return this.category.id;
  }

  private async onUpdate(): Promise<void> {
    if (!this.category) {
      return;
    }

    this.loading = true;
    this.showLoading();

    try {
      await this.loadImportantMessages();
    } catch {
      // do nothing
    }

    this.loadServices()
      .then(() => {
        this.updatedTime = new Date().getTime();
      })
      .catch((e) => {
        console.log(e);
        this.errorToast(this.$t(API_ERROR_MESSAGE.FAILED_TO_GET).toString());
      })
      .finally(() => {
        this.loading = false;
        this.hideLoading();
      });
  }

  private onClickService(service: ServiceInterface): void {
    if (!this.category) {
      return;
    }

    this.$router.push({
      name: RouteName.ServiceStatus,
      params: { key: this.category.routeKey },
      hash: `#service-${service.id}`,
    });
  }

  private onClickTab(category: ServiceCategoryInterface): void {
    if (this.category && this.category.id === category.id) {
      return;
    }

    this.category = category;
    this.serviceGroups = [];
    this.onUpdate();
    this.$router.replace({
      name: RouteName.Service,
      params: { key: category.routeKey },
    });
  }
}
